import { render, staticRenderFns } from "./OrderItemsPerStatusId.vue?vue&type=template&id=231530d6"
import script from "./OrderItemsPerStatusId.vue?vue&type=script&lang=js"
export * from "./OrderItemsPerStatusId.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsPerStatusId.vue?vue&type=style&index=0&id=231530d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports